import React, { useEffect, useState } from 'react';
import { TextField, Autocomplete } from '@mui/material';
import ObtenerEspecialidades from '../functions/ObtenerEspecialidades';
import EspecialidadSeleccionar from '../types/EspecialidadSeleccionar';

interface SeleccionarEspecialidadProps {
    especialidadInicial: number;
    onChange: (especialidad: EspecialidadSeleccionar) => void;
    onClear: () => void;
    eliminando: boolean;
  }

const SeleccionarEspecialidad: React.FC<SeleccionarEspecialidadProps> = ({ especialidadInicial, onChange, onClear, eliminando }) => {

    const [especialidades, setEspecialidades] = useState<EspecialidadSeleccionar[]>([]);
    const [especialidadSeleccionada, setEspecialidadSeleccionada] = useState<EspecialidadSeleccionar | null>({id: 0, especialidad: ''});

    const handleEspecialidadChange = (event: React.SyntheticEvent, newValue: EspecialidadSeleccionar | null) => {
        if (newValue === null) {
            setEspecialidadSeleccionada(null);
            if (onClear) {
                onClear();
            }
            return;
        }
        setEspecialidadSeleccionada(newValue);
        if (onChange) {
            onChange(newValue);
        }

        if (newValue === null && onClear) {
            onClear();
        }
    };

    const fetchEspecialidades = async () => {

        // Recupero los datos de las especialidades
        const dataEspecialidades = await ObtenerEspecialidades();
        if (dataEspecialidades.especialidades_ok === 'si') {

            const especialidadesRecuperadas: EspecialidadSeleccionar[] = [];
            for (const especialidad of dataEspecialidades.especialidades) {
                especialidadesRecuperadas.push({
                    id: especialidad.id,
                    especialidad: especialidad.especialidad
                });
            }

            setEspecialidades(especialidadesRecuperadas);
        }

        if (especialidadInicial > 0) {
            const especialidadInicio = dataEspecialidades.especialidades.find(
                (e: EspecialidadSeleccionar) => e.id === especialidadInicial
            );
            if (especialidadInicio) {
                setEspecialidadSeleccionada(especialidadInicio);
                onChange(especialidadInicio);
            }
        }
    };

    useEffect(() => {
        fetchEspecialidades();
    }, []);

    useEffect(() => {
        if (especialidadInicial === 0) {
            setEspecialidadSeleccionada(null);
        }
    }, [especialidadInicial]);

    return (
        <div className="flex flex-col w-full ">
            <Autocomplete<EspecialidadSeleccionar>
                options={especialidades}
                getOptionLabel={(option: EspecialidadSeleccionar) => `${option.especialidad}`}
                renderInput={(params) => <TextField {...params} label="Selecciona una especialidad" />}
                value={especialidadSeleccionada}
                onChange={handleEspecialidadChange}
                isOptionEqualToValue={(option: EspecialidadSeleccionar, value: EspecialidadSeleccionar) => option.id === value.id}
                renderOption={(props, option: EspecialidadSeleccionar) => (
                <li {...props}>
                    {option.especialidad}
                </li>
                )}
                disabled={eliminando}
                size="small"
            />
        </div>
    );
}

export default SeleccionarEspecialidad;